module.exports = __webpack_public_path__ + "static/img/holi.bc78482.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/holi.svg
// module id = qgL/
// module chunks = 0